<section 
   data-component="popup-site-bookmark"
   role="dialog"
   [attr.aria-describedby]= "ariaDescribedBy">
   <div data-card-wrapper="" class="{{showBrandValue}}"> 
      <div class="bookmark" id="popup_label_13"></div>
      <div class="bookmark_text" id="popup_label_14"> 
        <h3 [innerHTML]="bookmarkContent?.copy$$header_home_screen?.TEXT"></h3> 
    <p [innerHTML]="bookmarkContent?.copy$$info_tap_to_add_homescreen?.TEXT"></p>
    </div></div>
	<!--close button on top right corner-->
	<section class="close-modal">
		<button
      class="close-modal-icon text-button"
			[attr.aria-label]="bookmarkContent?.copy$$close_dialog?.WCAG_TEXT" 
			(click)="close()">
		</button>
	</section>
</section>